import { Component, OnInit } from '@angular/core';
import { OrderService } from '../order.service';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss']
})
export class OrdersComponent implements OnInit {
  p = 1;
  s = 1;
  listOfOrders: any = {};
  total: number;

  constructor(
    private orderService: OrderService
  ) { }

  ngOnInit() {
    this.getAllPagedOrders(1);
  }

  getAllPagedOrders(page: number) {
    this.orderService.getAllOrders().subscribe(Response => {
      // this.spin = true;
      debugger;
      this.listOfOrders = Response;
      console.log(Response);
      // this.total = Response.Page.TotalRecords;
      this.p = page;
      console.log('current page number', this.p);
      console.log(Response);
    });
  }

}
